module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container container-table"
  }, [_c('div', {
    staticClass: "row vertical-10p"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('img', {
    staticClass: "center-block logo",
    attrs: {
      "src": "/static/img/404-page-error.png"
    }
  }), _vm._v(" "), _c('span', [_vm._v("你迷路了嗎？")]), _vm._v(" "), _c('div', {
    staticClass: "text-center col-sm-6 col-sm-offset-3"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("請按此返回首頁")])], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5c02505c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/404.vue
// module id = 2442
// module chunks = 1